import React, { useEffect, useRef } from 'react';
import './style.scss'

import { useField } from '@unform/core';

function Pass({ name, titulo, col, ...props }) {
    const inputRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);

    return (
        <div className={`cInputD ${col}`}>            
            <label htmlFor={name}>{titulo}</label>            
            <input id={name} autoComplete='off' type='password' ref={inputRef} defaultValue={defaultValue} {...props} />
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
}

export default Pass